import { utils } from 'ui-common';

export const setDocusignReentryCookie = (data: { partyId; disclosuresPackageId; accessToken }) => {
  utils.cookieUtils.set('docusign_task_details', JSON.stringify(data), { path: '/' });
};
